/**
 * RegistrationInfo Component
 * 
 * Displays additional registration information and helpful resources
 * including contact information and downloadable guidelines.
 * 
 * @returns {JSX.Element} Registration information card
 */

import React from 'react';

const RegistrationInfo = () => {
  return (
    <div className="card mt-4 border-0">
      <div className="card-body text-center">
        <h6 className="text-conference-primary mb-3">
          <i className="bi bi-info-circle me-2"></i>
          Registration Information
        </h6>
        <div className="row g-3">
          <div className="col-md-12">
            <div className="text-muted">
              <i
                className="bi bi-calendar-check d-block mb-1"
                style={{ fontSize: "1.5rem" }}
              ></i>
              <small>
                If you have difficulty creating an account, please
                complete and send the form below and your manuscript to{" "}
                <a
                  href="mailto:mfs@mfsociety.org"
                  className="text-decoration-none text-conference-primary"
                >
                  <i className="bi bi-envelope me-1"></i>
                  mfs@mfsociety.org
                </a>
                . We will create an account for you and provide you with
                the relevant log-in information.
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegistrationInfo;
